import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AuthorizationRequestNotification } from '../authorization/models/authorization-request-notification.model';
import { UserNotification } from '../notification/models/user-notification.model';

@Injectable({
  providedIn: 'root'
})
export class SignalREventService {
  private authorizationRequestReceivedSource = new Subject<AuthorizationRequestNotification>();
  private userNotificationReceivedSource = new Subject<UserNotification>();

  constructor() { }

  authorizationRequestReceived$ = this.authorizationRequestReceivedSource.asObservable();
  userNotificationReceived$ = this.userNotificationReceivedSource.asObservable();

  authorizationRequestReceived(authorizationRequestNotification: AuthorizationRequestNotification) {
    this.authorizationRequestReceivedSource.next(authorizationRequestNotification);
  }

  userNotificationReceived(userNotification: UserNotification) {
    this.userNotificationReceivedSource.next(userNotification);
  }
}
